import React, { Component } from 'react';
import Button from '@material-ui/core/Button';
import { Dialog as MuiDialog, Typography } from '@material-ui/core';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import Proptypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';

class Dialog extends Component {
  constructor(props) {
    super(props);
    this.state = {
      sec: 0,
    };
  }

  setSec = () => {
    const { sec } = this.state;
    this.setState({ sec: sec + 1 });
  }

  render() {
    const {
      title,
      text,
      handleClose,
      agreeButtonSubmitStyle,
      open,
      agreeButton,
      disagreeButton,
      handleAccept,
      classes,
      noTimer,
      removeText,
      removeClick,
    } = this.props;
    const { sec } = this.state;

    if (open && sec < 3) {
      setTimeout(this.setSec, 1000);
    }

    return (
      <MuiDialog
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">
          {removeText !== '' && (
            <Typography variant="subtitle2" className={classes.deactivateText} onClick={removeClick}>
              {removeText}
            </Typography>
          )}
          {title}
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            {text}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button variant="outlined" onClick={handleClose} color="primary">
            {disagreeButton}
          </Button>
          <div>
            {!noTimer ? (
              <Button disabled={sec < 3} color={agreeButtonSubmitStyle ? "primary" : ""} variant={agreeButtonSubmitStyle ? "contained" : "outlined"} onClick={() => { handleAccept(); handleClose(); }} className={ agreeButtonSubmitStyle ? '' : classes.accept}>
                {sec >= 3 ? agreeButton : `Vent ${3 - sec} sek`}
              </Button>
            ) : (
              <Button color={agreeButtonSubmitStyle ? "primary" : ""} variant={agreeButtonSubmitStyle ? "contained" : "outlined"} onClick={() => { handleAccept(); handleClose(); }} className={ agreeButtonSubmitStyle ? '' : classes.accept}>
                {agreeButton}
              </Button>
            )}
          </div>
        </DialogActions>
      </MuiDialog>
    );
  }
}

const styles = theme => ({
  accept: {
    color: '#f00',
    borderColor: '#f00',
  },
  deactivateText: {
    color: theme.palette.error.main,
    textDecoration: 'underline',
    marginBottom: '1rem',
    cursor: 'pointer',
  },
});

Dialog.propTypes = {
  title: Proptypes.string,
  text: Proptypes.any,
  handleClose: Proptypes.func,
  handleAccept: Proptypes.func,
  agreeButtonSubmitStyle: Proptypes.bool,
  open: Proptypes.bool.isRequired,
  agreeButton: Proptypes.any,
  disagreeButton: Proptypes.any,
  classes: Proptypes.object.isRequired,
  noTimer: Proptypes.bool,
  removeText: Proptypes.string,
  removeClick: Proptypes.func,
};

Dialog.defaultProps = {
  title: '',
  text: '',
  agreeButtonSubmitStyle: false, 
  handleClose: () => {},
  handleAccept: () => {},
  agreeButton: 'Deaktiver',
  disagreeButton: 'Avbryt',
  noTimer: false,
  removeText: '',
  removeClick: () => {},
};

Dialog.propComments = {
  title: 'Title for dialog.',
  text: 'Text inside dialog.',
  handleClose: 'Function describing what happens when dialog closes.',
  handleAccept: 'Function describing what happens when accept button is clicked',
  open: 'A variable defining the dialogs visibility.',
  agreeButton: 'Text for the agree button.',
  disagreeButton: 'Text for the disagree button.',
};

export default withStyles(styles)(Dialog);
